import { render, staticRenderFns } from "./ModalRep.vue?vue&type=template&id=62d652ce&scoped=true&"
import script from "./ModalRep.vue?vue&type=script&lang=ts&"
export * from "./ModalRep.vue?vue&type=script&lang=ts&"
import style0 from "./ModalRep.vue?vue&type=style&index=0&id=62d652ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d652ce",
  null
  
)

export default component.exports